import {
  Component,
  HostListener,
  inject,
  OnInit,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TreeViewProviderDirective } from '@app/providers/tree-view-provider.service';
import { EarhivUiComponents } from '@app/shared/models/earhiv-ui-components';
import { ARHIV_POSJEDNIK } from '@app/shared/models/types';
import {
  BackendDataSourceService,
  FilterView,
  FilterViewProviderDirective,
  Item,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  NtapCommonComponent,
  NtapGlobalConstants,
  UIComponents,
  Util,
  ViewData,
  ViewState
} from '@ntap/core';
import { MessageService, TreeDragDropService, TreeNode } from 'primeng/api';
import { Tree } from 'primeng/tree';
import {
  BehaviorSubject,
  concat,
  debounceTime,
  distinctUntilKeyChanged,
  filter,
  first,
  map,
  Observable,
  Subject,
  tap
} from 'rxjs';
import { ParentListViewProvider } from '../pretraga-kataloga/providers/parent-list-view.provider';
import { EarhivTreeNode } from './types';
import {
  isNerazvrstanoJedinica,
  isRootJedinica
} from '@app/shared/util/common-utils';

export const TYPE_jedinica_gradiva = 'en~jedinica_gradiva'; // ! ~
export const FQAN_jedgrad_id = Util.getFullAttrName(
  TYPE_jedinica_gradiva,
  'id'
);
export const FQAN_glavni_naziv = Util.getFullAttrName(
  TYPE_jedinica_gradiva,
  'glavni_naziv'
);
export const FQAN_razina = Util.getFullAttrName(
  TYPE_jedinica_gradiva,
  'razina'
);
export const FQAN_nadred_jedgrad = Util.getFullAttrName(
  TYPE_jedinica_gradiva,
  'nadredena_jedinica_gradiva'
);
export const FQAN_posjednik_id = Util.getFullAttrName(ARHIV_POSJEDNIK, 'id');
export const KEY_$parentNode = '$parentNode';

export const RAZINA_PREDMET = 6;

export enum Razina {
  FOND = 1,
  ZBIRKA = 2,
  PODFOND = 3,
  SERIJA = 4,
  GRUPA = 5,
  PREDMET = 6,
  DIO_PREDMETA = 7,
  DOKUMENT = 8
}
const ICON_MAP = 'pi pi-fw pi-book';
const CHILDREN_DEBOUNCE = 400;

export const DEFAULT_PAGE_LIMIT = 100;

export const INITAL_ROOT_VIEWSTATE = {
  $paging_offset: 0,
  $paging_limit: DEFAULT_PAGE_LIMIT
};

@Component({
  selector: 'app-hierarhija',
  templateUrl: './hierarhija.component.html',
  styleUrls: ['./hierarhija.component.scss'],
  providers: [
    TreeDragDropService,
    MessageService,
    TreeViewProviderDirective,
    FilterViewProviderDirective,
    {
      provide: ListViewProviderDirective,
      useExisting: TreeViewProviderDirective
    },
    {
      provide: ParentListViewProvider,
      useExisting: TreeViewProviderDirective
    },
    BackendDataSourceService
  ]
})
export class HierarhijaComponent extends NtapCommonComponent implements OnInit {
  @ViewChild(Tree)
  public tree: Tree;

  @ViewChild('childrenListViewProvider')
  childrenListViewProvider: ListViewProviderDirective<ListView>;

  sizes: number[] = [30, 70];
  isCollapsed = false;

  toggleLeft() {
    this.isCollapsed = !this.isCollapsed;
    this.sizes = this.isCollapsed ? [0, 100] : [30, 70];
  }

  // @ViewChild(ListToolBarComponent)
  // public toolbar: ListToolBarComponent;

  private _childrenListNode$: Subject<EarhivTreeNode> = new Subject();
  public readonly childrenListState$: Observable<ViewState> =
    this._childrenListNode$.pipe(
      distinctUntilKeyChanged('id'), // node.id
      debounceTime(CHILDREN_DEBOUNCE),
      map((node) => this.newChildrenViewState(node))
    );

  private newChildrenViewState(node: EarhivTreeNode): ViewState {
    return {
      [FQAN_nadred_jedgrad]: node.id, //node.data[FQAN_nadred_jedgrad],
      [NtapGlobalConstants.ATTR_$parentType]:
        node.data[NtapGlobalConstants.ATTR_$itemType], //TYPE_jedinica_gradiva,
      [NtapGlobalConstants.ATTR_$parentId]: node.id,
      [NtapGlobalConstants.ATTR_$parent]: node.data
    };
  }

  private route = inject(ActivatedRoute);
  private routeState: any = {};

  public showDeleteButton = false;
  public tableToolbarCompId = UIComponents.LISTTOOLBAR;
  public tableToolbarCompId1 = EarhivUiComponents.EDIT_ACTIONBAR;
  public childrenListViewCompId = UIComponents.LISTVIEW;

  files1$: Observable<TreeNode[]>;
  // viewData$: Observable<ViewData>;
  loadingState$: Observable<boolean>;
  displayItems$: Observable<ViewData>;
  treeTitle = new BehaviorSubject('');
  treeTitle$: Observable<string>;
  title = 'Opći inventar';
  showToolbarTitle = true;
  filterViewName = 'filter_strukture_gradiva';
  rootViewName = this.filterViewName;
  nodesViewName = 'jedinica_gradiva_hijerarhija';
  filterViewState: object = {};
  propagateSelectionUp = false;
  propagateSelectionDown: boolean;
  showCustomToolbar = true;
  selectionMode: 'single' | 'multiple' | 'checkbox' | null | undefined =
    'checkbox';
  rootNodesSelectable = false;
  childrenListViewName = '';
  useChildrenListView = false;
  // todo: prebaciti u dokumentacija-hijerarhija
  useMergedSearchView = false;
  mergedSearchViewName = '';
  mergedSearchViewState: object = {};
  mergedSearchViewStateFilter: object = {};
  isTreeShown = true;
  autoExpandOnSingleRoot = true;
  nerazvrstano = false;

  @HostListener('keydown.shift', ['$event'])
  onKeyDown() {
    this.propagateSelectionDown = true;
  }

  @HostListener('keyup.shift', ['$event'])
  onKeyUp() {
    this.propagateSelectionDown = false;
  }
  private notificationService = inject(NotificationService);
  private rootPageOffset = 1;

  constructor(
    protected msg: MessageService,
    protected router: Router,
    protected listViewProvider: TreeViewProviderDirective,
    protected filterViewProviderDirective: FilterViewProviderDirective<FilterView>
  ) {
    super();
    this.loadingState$ = this.listViewProvider.loadingState$;
    this.files1$ = this.listViewProvider.treeViewData$.pipe(
      map((roots) => {
        if (this.autoExpandOnSingleRoot && roots.length === 1) {
          roots[0].expanded = true;
          this.nodeExpand({ node: roots[0] });
        }
        return roots;
      })
    );
    this.addFilterSubscription(); //@ebesbor privremeno zakomentirano jer breaka opci inventar
  }

  protected addFilterSubscription() {
    this.addSubscription(
      this.filterViewProviderDirective.viewData$.subscribe(
        (filterState: any) => {
          this.nerazvrstano = filterState['en.arhiv_posjednik.nerazvrstano'];
          this.isTreeShown = this.isFilterStateEmpty(filterState);
          if (!this.useMergedSearchView) {
            this.fetchRoots(this.newRootState(filterState));
            this.rootPageOffset = 1;
          } else {
            this.mergedSearchViewState = filterState;
          }
        }
      )
    );
  }

  private isFilterStateEmpty(filterState: ViewData) {
    return !Object.values(filterState).some(
      (x) => x !== null && String(x) !== ''
    );
  }

  protected getInitRootViewState() {
    return INITAL_ROOT_VIEWSTATE;
  }

  protected getInitViewState(): any {
    return INITAL_ROOT_VIEWSTATE;
  }

  ngOnInit() {
    this.initNavigationStateSubscription();
    this.listViewProvider.mapRoots = this.mapRoots;
    this.listViewProvider.mapNodes = this.mapNodes;
    this.listViewProvider.rootViewName = this.rootViewName;
    this.listViewProvider.viewName = null as any;
    this.listViewProvider.viewName = this.nodesViewName;
    this.listViewProvider.viewState = null as any;
    this.listViewProvider.viewState = this.getInitViewState();
    this.filterViewProviderDirective.viewName = this.filterViewName;
    this.filterViewProviderDirective.viewState = this.filterViewState;
    this.fetchRoots(this.getInitRootViewState());
    // grab first view title
    this.treeTitle$ = concat(
      this.treeTitle.asObservable(),
      this.listViewProvider.view$.pipe(
        filter((v) => !!v.title),
        first(),
        map((v) => v.title ?? '')
      )
    );
  }

  protected newRootState(filterState: Item): ViewState {
    return Object.assign({}, this.getInitRootViewState(), filterState);
  }

  fetchRoots(rootsViewState: any) {
    this.listViewProvider.rootViewState = rootsViewState;
  }

  private static readonly DEFAULT_DROP_MESSAGE =
    'Jeste li sigurni da želite premjestiti jedinicu gradiva uključujući i sve jedinice gradiva na nižim razinama?';

  displayDialog = false;
  dropDialogMessage = HierarhijaComponent.DEFAULT_DROP_MESSAGE;
  pendingDropEvent: any;
  private isRootDrop = false;

  confirmDrop() {
    const event = this.pendingDropEvent;
    let parentNode = event.dropNode;
    const nodeDroppedInline =
      event.originalEvent.target.className.indexOf('p-treenode-droppoint') ===
      0;
    const nextNodeIndex = event.index;
    const dropNodeParent = event.dropNode.parent.data;

    const selectedNode = event.dragNode.data;
    let nodeWhereToDrop = event.dropNode.data;
    let redoslijed = 0;

    if (nodeDroppedInline) {
      redoslijed = nextNodeIndex + 1;
      nodeWhereToDrop = dropNodeParent;
      parentNode = event.dropNode.parent;
    }
    console.log('SELECTED NODE', selectedNode);
    console.log('SELECTED TARGET', nodeWhereToDrop);
    console.log('REDOSLIJED', redoslijed);
    console.log('DROP NODE PARENT', dropNodeParent);

    this.listViewProvider
      .executeAction('potvrdiPremjestanje', {
        $selected: [selectedNode],
        $selectedTargets: [nodeWhereToDrop],
        $redoslijed: redoslijed
      })
      .subscribe({
        next: () => {
          this.notificationService.success('Uspješno ste premjestili!');
          this.listViewProvider.nodeRefresh(parentNode);
        },
        error: (errorMessage) => {
          this.notificationService.error(errorMessage);
          this.listViewProvider.nodeRefresh(parentNode);
        }
      });

    // Close the dialog
    this.displayDialog = false;
    this.pendingDropEvent = null;

    if (!this.isRootDrop) {
      event.accept();
    }
  }

  onNodeDrop(event: any) {
    this.pendingDropEvent = event;
    // Za "between" drop, stvarni target je parent dropNode-a
    const isBetweenDrop = event.dropPoint === 'between';
    const effectiveTarget = isBetweenDrop
      ? event.dropNode?.parent?.data
      : event.dropNode?.data;
    this.isRootDrop =
      isRootJedinica(effectiveTarget) ||
      effectiveTarget?.['$itemType'] === 'en~arhiv_posjednik';
    if (this.isRootDrop) {
      this.dropDialogMessage =
        'Premještate jedinicu na razinu fonda/zbirke. Redoslijed će biti automatski dodijeljen (zadnja pozicija). Želite li nastaviti?';
    } else {
      this.dropDialogMessage = HierarhijaComponent.DEFAULT_DROP_MESSAGE;
    }
    this.displayDialog = true;
  }

  loadMoreRoots(): Observable<any> {
    const newPageOffset = (this.rootPageOffset += 1);
    return this.listViewProvider
      .loadMoreRoots({
        $paging_offset: this.rootPageOffset * DEFAULT_PAGE_LIMIT,
        $paging_limit: DEFAULT_PAGE_LIMIT
      })
      .pipe(
        tap(() => {
          this.rootPageOffset = newPageOffset;
        })
      );
  }

  loadMoreRootsClick() {
    this.loadMoreRoots().subscribe();
  }

  loadMore(node: any) {
    const requestState = this.newLoadMoreState(node);
    this.listViewProvider
      .loadMore(node.parent, requestState, DEFAULT_PAGE_LIMIT)
      .subscribe((res) => {
        if (res.length < DEFAULT_PAGE_LIMIT) {
          this.msg.add({
            severity: 'info',
            summary: 'Obavijest',
            detail: `Učitali ste sve podatke za ${node.parent.label}`
          });
        }
      });
  }

  protected newLoadMoreState(node: any) {
    const arhivPosjednikId = node.parent?.data[FQAN_posjednik_id];
    const jedinicaGradivaId = node.parent?.data[FQAN_jedgrad_id];

    return arhivPosjednikId
      ? Object.assign({}, this.listViewProvider.viewState, {
          'en~jedinica_gradiva~posjednik': arhivPosjednikId,
          $paging_offset: node.parent.offset,
          $paging_limit: DEFAULT_PAGE_LIMIT
        })
      : jedinicaGradivaId
      ? Object.assign({}, this.listViewProvider.viewState, {
          [FQAN_nadred_jedgrad]: jedinicaGradivaId,
          $paging_offset: node.parent.offset,
          $paging_limit: DEFAULT_PAGE_LIMIT
        })
      : null;
  }

  nodeExpand(event: any) {
    // const requestState = this.newExpandedChildrenViewState(event.node);
    // this.listViewProvider
    //   .nodeExpand(event.node, requestState, DEFAULT_PAGE_LIMIT)
    //   .subscribe();
    this.nodeExpandObservable(event).subscribe();
  }

  nodeExpandObservable(event: any): Observable<any> {
    const requestState: any = this.newExpandedChildrenViewState(event.node);

    // TODO vjerojatno bi bilo bolje imati neki currentFilter @Input koji bi onda omogucio filtriranje trenutne hijerarhije i po nekim drugim parametrima
    // a postavljao bi se izvana na temelju search filtera
    const isMojeGradivo =
      this.route.snapshot.data['isMojeGradivo'] ||
      this.routeState['isMojeGradivo'];
    if (isMojeGradivo) {
      Object.assign(requestState, { $filterMojeGradivo: isMojeGradivo });
    }

    return this.listViewProvider.nodeExpand(
      event.node,
      requestState,
      DEFAULT_PAGE_LIMIT
    );
  }

  protected newExpandedChildrenViewState(node: EarhivTreeNode) {
    const arhivPosjednikId = node.data[FQAN_posjednik_id]
      ? node.data[FQAN_posjednik_id]
      : null;
    const jedinicaGradivaId = node.data[FQAN_jedgrad_id]
      ? node.data[FQAN_jedgrad_id]
      : null;
    const requestState = arhivPosjednikId
      ? Object.assign({}, this.listViewProvider.viewState, {
          'en~jedinica_gradiva~posjednik': arhivPosjednikId,
          'en~jedinica_gradiva~nerazvrstano': this.nerazvrstano
        })
      : jedinicaGradivaId
      ? Object.assign({}, this.listViewProvider.viewState, {
          [FQAN_nadred_jedgrad]: jedinicaGradivaId,
          'en~jedinica_gradiva~nerazvrstano': this.nerazvrstano
        })
      : null;
    return requestState;
  }

  nodeCollapse(event: any) {
    this.listViewProvider.nodeCollapse(event.node);
  }

  public mapRoots = (rootsResponse: Observable<any[]>): Observable<any[]> => {
    return rootsResponse.pipe(
      map((roots) => {
        const loadedNodes: EarhivTreeNode[] = roots.map((element) =>
          this.newRootNode(element)
        );
        if (loadedNodes.length >= DEFAULT_PAGE_LIMIT) {
          const loadMoreNode: any = {
            type: 'urlRoot',
            selectable: false,
            draggable: false,
            droppable: false,
            label: 'Učitaj više.'
            // icon: "pi pi-arrow-down",
          };
          this.injectProperty(loadMoreNode, KEY_$parentNode);
          loadedNodes.push(loadMoreNode);
        }
        return loadedNodes;
      })
    );
  };

  protected newRootNode(element: any): EarhivTreeNode {
    return {
      data: element,
      label: this.getRootNodeLabel(element) || '',
      icon: this.getRootNodeIcon(),
      children: [],
      leaf: false,
      selectable: this.rootNodesSelectable,
      draggable: false,
      droppable: false,
      id: HierarhijaComponent.getElementId(element),
      offset: 0
    } as EarhivTreeNode;
  }

  protected getRootNodeLabel(element: any): string {
    return `${element['en~arhiv_posjednik~oznaka'] || ''}   ${
      element['en~agent~naziv'] || ''
    }`;
  }

  protected getRootNodeIcon(): string {
    return ICON_MAP;
  }

  public mapNodes = (
    response: any,
    parentNode?: TreeNode
  ): EarhivTreeNode[] => {
    const loadedNodes: EarhivTreeNode[] = [];
    response.forEach((element: any) => {
      // definiramo vezu prema parent node-u na podacima,
      // ali preko defineProperty da izbjegnemo cirkularnu serijalizaciju u JSON
      this.injectProperty(element, KEY_$parentNode);
      element.$parentNode = parentNode;
      const node = this.newNode(element);
      loadedNodes.push(node);
    });

    // Prije se gledao length > 0 i $itemsCount što ne valja jer je $itemsCount totalni broj.
    // Idealno bi bilo da se gleda koliko node ima siblinga i to usporedi sa $itemsCount.
    if (loadedNodes.length >= DEFAULT_PAGE_LIMIT) {
      const loadMoreNode: any = {
        type: 'url',
        selectable: false,
        draggable: false,
        droppable: false,
        label: 'Učitaj više.',
        // icon: "pi pi-arrow-down",
        parent: parentNode
      };

      this.injectProperty(loadMoreNode, KEY_$parentNode);
      loadMoreNode.$parentNode = parentNode;
      loadMoreNode.parent = parentNode;
      loadedNodes.push(loadMoreNode);
    }

    return loadedNodes;
  };

  private injectProperty(obj: any, propName: string) {
    Object.defineProperty(obj, propName, {
      value: 'static',
      writable: true
    });
  }

  protected newNode(element: any): EarhivTreeNode {
    const isFondOrZbirka =
      isRootJedinica(element) && !isNerazvrstanoJedinica(element);
    return {
      data: element,
      label: this.getNodeLabel(element) || '',
      // icon: this.getNodeIcon(element),
      lockedIconClass: this.getNodeLockIcon(element),
      children: [],
      leaf: false,
      selectable: true,
      draggable: !isFondOrZbirka,
      id: HierarhijaComponent.getElementId(element),
      parent: element[KEY_$parentNode],
      offset: 0
    } as EarhivTreeNode;
  }

  protected getNodeLabel(element: any) {
    return (
      (element['en~jedinica_gradiva~arhivska_oznaka'] || '') +
      ' ' +
      (element[FQAN_glavni_naziv] || '')
    );
  }

  protected getNodeLockIcon(element: any): string {
    return element['en~jedinica_gradiva~locked']
      ? 'lock-status p-treenode-icon pi pi-lock'
      : 'lock-status p-treenode-icon pi pi-lock-open';
  }

  public static getElementId(element: any) {
    const idAttr = Util.getFullAttrName(
      element[NtapGlobalConstants.ATTR_$itemType],
      NtapGlobalConstants.ATTR_id
    );
    return element[idAttr];
  }

  public static setNodeId(node: EarhivTreeNode, element: any) {
    node.id = HierarhijaComponent.getElementId(element);
  }

  get selectedFiles() {
    return this.listViewProvider.selectedNodes;
  }

  set selectedFiles(values) {
    this.listViewProvider.selectedNodes = values;
  }

  onNodeSelect(event: any) {
    if (this.useChildrenListView && this.isChildrenViewAvailable(event.node)) {
      this._childrenListNode$.next(event.node);
      this.treeTitle.next(event.node.label);
      // this.toolbar.viewTitleService.setViewTitle(event.node.label);
    }
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  protected isChildrenViewAvailable(node: any): boolean {
    return false;
  }

  private initNavigationStateSubscription() {
    this.addSubscription(
      this.router.events.subscribe((event: any) => {
        if (event.routerEvent instanceof NavigationEnd) {
          const state = this.router.lastSuccessfulNavigation?.extras?.state;
          if (state) {
            this.routeState = state;
          }
        }
      })
    );
  }
}
